<template>
	<header>
		<h1><a href="/" title="Zkušební promítání">ArtKina<span> - Program artových kin v ČR</span></a></h1>
		<nav class="menu">
			<ul>
				<li class="appstore"><a href="http://bit.ly/aiosweb" target="_blank"><span>App Store</span></a></li>
				<li class="googleplay"><a href="http://bit.ly/akgpweb" target="_blank"><span>Google Play</span></a></li>
				<li class="about"><a href="#" @click.prevent="openAboutLightbox()">Informace</a></li>
			</ul>
		</nav>
		<aside>
			<nav>
				<ul>
					<li class="back" v-if="hasPreviousBtn"><a href="#" @click.prevent="showSection('previous')">{{prevSection.title}}</a></li>
					<li class="next" v-if="hasNextBtn"><a href="#" @click.prevent="showSection('next')">{{nextSection.title}}</a></li>
				</ul>
			</nav>
		</aside>
	</header>
</template>

<script>
export default {
	computed: {
		hasPreviousBtn: function () {
			return this.$store.state.activeSectionIndex > 0
		},
		hasNextBtn: function () {
			const sections = this.$store.state.sections
			return this.$store.state.activeSectionIndex < sections.length - 1
		},
		prevSection: function () {
			const { activeSectionIndex: index, sections } = this.$store.state
			return sections[index - 1]
		},
		nextSection: function () {
			const { activeSectionIndex: index, sections } = this.$store.state
			return sections[index + 1]
		}
	},
	methods: {
		showSection: function (type) {
			const prevIndex = this.$store.state.activeSectionIndex - 1
			const nextIndex = this.$store.state.activeSectionIndex + 1
			const sections = this.$store.state.sections
			switch (type) {
			case 'previous':
				if (prevIndex >= 0) {
					this.$store.commit('activeSectionIndex', prevIndex)
				}
				break
			case 'next':
				if (nextIndex < sections.length) {
					this.$store.commit('activeSectionIndex', nextIndex)
				}
				break
			}
		},
		openAboutLightbox: () => {
			document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-about')
		}
	}
}
</script>

<style lang=less scoped>
	@import "../assets/less/default.less";
	header { display: flex; position: relative; height: 100px; padding-left: 2em; align-items: center; text-align: center;  .bgc(@redDark);
		h1 { display: flex; .bg('../images/sprites/logo.png', 0 50% / contain); padding-left: 60px; font-size: 2em; letter-spacing: 5px;
			a { color: #fff; text-decoration: none; line-height: 1; margin: auto; padding: 9px;
				&:after { display: block; content: attr(title); padding-right: 4px; font-size: 14px; text-align: right; letter-spacing: 0; opacity: .5; }
			}
			span { display: none; }
		}
		nav.menu ul { display: flex; }
		nav {
			a span { display: none; }
			ul { .top-right(50%,2em); margin-top: -15px; }
			li { display: inline-block; padding-left: .8rem; }
			li a:hover { opacity: .5; }
			li.appstore a { display: inline-block; .size(30px); .bg('../images/download-apple.png', 0 0 / contain); }
			li.googleplay a { display: inline-block; .size(30px); .bg('../images/download-android.png', 0 0 / contain); }
			li.about a { display: inline-block; .size(10px,30px); .bg('../images/sprites/ico-info.png', 100% 50% / contain); text-indent: 100%; white-space: nowrap; overflow: hidden; }
		}
		aside {
			ul {
				li.back, li.next { display: none; }
			}
		}
	}

	@media @tablet {
		header { justify-content: center; }
		aside {
			nav {
				ul { right: auto; left: 15px;
					li.back, li.next { display: block; }
					li { padding: 0;
						&.back, &.next { display: block; }
						a { text-transform: uppercase; text-decoration: none; font-size: 1.8rem; font-family: "bebas-neue", sans-serif; color: @cremeLight; }
						&.back a {
							&:before { content: "\000AB "; }
						}
						&.next a {
							&:after { content: " \000BB"; }
						}
					}
					li.back + li.next { display: none; }
				}
			}
		}
	}

	@media @mobile {
		header { height: 20%; padding: 0; flex-direction: column; align-items: flex-start; .bottom-left-dot(@gold); .bottom-right-dot(@gold);
			h1 { position: relative; height: 60%; padding-left: 15vw; margin-left: 1rem; font-size: 8vw; background-size: 20vw;
				a:after { font-size: 4vw; }
			}
			nav {
				ul { position: relative; top: auto; right: auto; margin-top: 0; }
				&.menu { .top-right(20%,1em); }
			}
			aside { .bottom-left(); z-index: 1; width: 100%; height: 40%; background-color: @gold; .top-left-dot(); .top-right-dot();
				nav { height: 100%; }
				ul { display: flex; height: 100%; flex-direction: row; justify-content: space-between; align-items: center;
					li { padding: 0 3vmax;
						&.back, &.next { display: block; }
						a { text-transform: uppercase; text-decoration: none; font-size: 1.2rem; font-family: "bebas-neue", sans-serif; color: @red; }
						&.back a {
							&:before { content: " \000AB"; padding-right: .5ex; }
						}
						&.next a {
							&:after { content: "\000BB "; padding-left: .5ex; }
						}
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Heading.vue